import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, HostBinding, Directive, ContentChild, ViewChild, ContentChildren, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@eui/components/eui-icon';
import { EuiIconModule } from '@eui/components/eui-icon';
import { EuiListComponent } from '@eui/components/eui-list';
import * as i1$1 from '@angular/cdk/overlay';
import { ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';
import { Subject, BehaviorSubject, Subscription, takeUntil, fromEvent } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import * as i2$1 from '@angular/cdk/a11y';
import { ActiveDescendantKeyManager, A11yModule } from '@angular/cdk/a11y';
import { BaseDirective } from '@eui/components/shared';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';

class EuiDropdownItemComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.role = 'menuitem';
        this._isActive = false;
    }
    get cssClasses() {
        return [
            'eui-dropdown-item',
            this.isActive ? `eui-dropdown-item--active` : ``,
            this.subDropdown ? `eui-dropdown-item--has-subdropdown` : ``,
        ].join(' ').trim();
    }
    get isActive() { return this._isActive; }
    set isActive(value) { this._isActive = coerceBooleanProperty(value); }
    setActiveStyles() {
        this.isActive = true;
    }
    ;
    setInactiveStyles() {
        this.isActive = false;
    }
    focus() {
        this.elementRef.nativeElement.focus();
    }
    click() {
        this.elementRef.nativeElement.click();
    }
}
/** @nocollapse */ EuiDropdownItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiDropdownItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiDropdownItemComponent, selector: "eui-dropdown-item, [euiDropdownItem]", inputs: { subDropdown: "subDropdown", isActive: "isActive" }, host: { properties: { "attr.role": "this.role", "class": "this.cssClasses" } }, ngImport: i0, template: "<div class=\"eui-dropdown-item__container\">\n    <div class=\"eui-dropdown-item__content\">\n        <div class=\"eui-dropdown-item__content-text\">\n            <ng-content></ng-content>\n        </div>\n        <div *ngIf=\"subDropdown\" class=\"eui-dropdown-item__content-icon\">\n            <eui-icon-svg icon=\"eui-chevron-forward\" set=\"eui\" size=\"s\" fillColor=\"grey-100\"></eui-icon-svg>\n        </div>\n    </div>\n</div>\n", styles: [".eui-dropdown .eui-dropdown__trigger-container{display:inline}.eui-dropdown__panel-container{background:#fff;border-radius:4px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;height:auto;display:block;position:relative;min-width:8rem}.eui-dropdown__panel-container .eui-dropdown-item{background:none;border:none;box-shadow:none;cursor:pointer;display:block;outline:none;padding:var(--eui-base-spacing-xs) var(--eui-base-spacing-s);position:relative;-webkit-tap-highlight-color:transparent;text-align:left;text-decoration:none;-webkit-user-select:none;user-select:none;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container{align-items:center;display:flex}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content,.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-text{align-items:center;display:flex;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-icon{align-items:center;display:flex;margin-left:var(--eui-base-spacing-s)}.eui-dropdown__panel-container .eui-dropdown-item:hover{background-color:var(--eui-base-color-grey-5)}.eui-dropdown__panel-container .eui-dropdown-item--active{background-color:var(--eui-base-color-grey-10)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.EuiIconSvgComponent, selector: "eui-icon-svg, span[euiIconSvg], i[euiIconSvg]", inputs: ["icon", "size", "fillColor", "set", "ariaLabelledby", "role", "style", "iconUrl", "aria-label", "ariaHidden", "focusable", "isLoading"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-dropdown-item, [euiDropdownItem]', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"eui-dropdown-item__container\">\n    <div class=\"eui-dropdown-item__content\">\n        <div class=\"eui-dropdown-item__content-text\">\n            <ng-content></ng-content>\n        </div>\n        <div *ngIf=\"subDropdown\" class=\"eui-dropdown-item__content-icon\">\n            <eui-icon-svg icon=\"eui-chevron-forward\" set=\"eui\" size=\"s\" fillColor=\"grey-100\"></eui-icon-svg>\n        </div>\n    </div>\n</div>\n", styles: [".eui-dropdown .eui-dropdown__trigger-container{display:inline}.eui-dropdown__panel-container{background:#fff;border-radius:4px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;height:auto;display:block;position:relative;min-width:8rem}.eui-dropdown__panel-container .eui-dropdown-item{background:none;border:none;box-shadow:none;cursor:pointer;display:block;outline:none;padding:var(--eui-base-spacing-xs) var(--eui-base-spacing-s);position:relative;-webkit-tap-highlight-color:transparent;text-align:left;text-decoration:none;-webkit-user-select:none;user-select:none;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container{align-items:center;display:flex}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content,.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-text{align-items:center;display:flex;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-icon{align-items:center;display:flex;margin-left:var(--eui-base-spacing-s)}.eui-dropdown__panel-container .eui-dropdown-item:hover{background-color:var(--eui-base-color-grey-5)}.eui-dropdown__panel-container .eui-dropdown-item--active{background-color:var(--eui-base-color-grey-10)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { subDropdown: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], isActive: [{
                type: Input
            }] } });

// eslint-disable-next-line @angular-eslint/directive-selector
class EuiDropdownContentDirective {
    constructor() { }
}
/** @nocollapse */ EuiDropdownContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ EuiDropdownContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: EuiDropdownContentDirective, selector: "eui-dropdown-content", queries: [{ propertyName: "euiList", first: true, predicate: EuiListComponent, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'eui-dropdown-content' }]
        }], ctorParameters: function () { return []; }, propDecorators: { euiList: [{
                type: ContentChild,
                args: [EuiListComponent]
            }] } });

const openClose = trigger('openClose', [
    state('open', style({
        opacity: 1,
        transform: 'scale(1)',
    })),
    state('closed', style({
        opacity: 0,
        transform: 'scale(0.9)',
    })),
    transition('closed => open', [
        animate('100ms 25ms linear'),
    ]),
]);

class EuiDropdownComponent extends BaseDirective {
    constructor(overlay, viewContainerRef, scrollDispatcher) {
        super();
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.scrollDispatcher = scrollDispatcher;
        /** @deprecated it will be removed in next eUI version */
        this.e2eAttr = 'eui-dropdown';
        this.tabIndex = -1;
        this.width = 'auto';
        this.position = 'bottom';
        this.trapFocusAutoCapture = true;
        this._isDropDownRightAligned = false;
        this._isClosedOnClickInside = true;
        this._isLabelUpdatedFromSelectedItem = false;
        this.originX = 'start';
        this.originY = 'bottom';
        this.overlayX = 'start';
        this.overlayY = 'top';
        this.fallbackOriginX = 'center';
        this.fallbackOriginY = 'bottom';
        this.fallbackOverlayX = 'center';
        this.fallbackOverlayY = 'top';
        this.destroy$ = new Subject();
        this.isOpen$ = new BehaviorSubject(false);
        this.scrollDispatcherSubscription = new Subscription();
        this.keydownListenerSubscription = new Subscription();
        this.euiDropdownItemsClickSubscriptions = [];
        this.activeDescendantKeyManagerChangeSubscription = new Subscription();
    }
    get isDropDownRightAligned() { return this._isDropDownRightAligned; }
    set isDropDownRightAligned(value) { this._isDropDownRightAligned = coerceBooleanProperty(value); }
    get isClosedOnClickInside() { return this._isClosedOnClickInside; }
    set isClosedOnClickInside(value) { this._isClosedOnClickInside = coerceBooleanProperty(value); }
    get isLabelUpdatedFromSelectedItem() { return this._isLabelUpdatedFromSelectedItem; }
    set isLabelUpdatedFromSelectedItem(value) { this._isLabelUpdatedFromSelectedItem = coerceBooleanProperty(value); }
    get cssClasses() {
        return [
            super.getCssClasses('eui-dropdown'),
        ].join(' ').trim();
    }
    ngOnInit() {
        this.setPosition();
    }
    ngAfterViewInit() {
        this.templatePortal = new TemplatePortal(this.templatePortalContent, this.viewContainerRef);
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        this.euiDropdownItemsClickSubscriptions.forEach((euiDropdownItemsClickSubscription) => {
            euiDropdownItemsClickSubscription.unsubscribe();
        });
        this.keydownListenerSubscription.unsubscribe();
        this.scrollDispatcherSubscription.unsubscribe();
        this.activeDescendantKeyManagerChangeSubscription.unsubscribe();
        this.overlayRef?.dispose();
        this.overlayRef = null;
        this.activeDescendantKeyManager = null;
    }
    /**
     * Whether the eui-dropdown is open.
     *
     * @usageNotes
     * ```html
     * <eui-dropdown #dropdown>
     *      <my-component *ngIf="dropdown.isOpen"></my-component>
     * </eui-dropdown>
     * ```
     * @returns A boolean with value `true` when open, otherwise `false`.
     */
    get isOpen() {
        return this.isOpen$.value;
    }
    onTriggerClicked(e) {
        if (!e.target.querySelector('.disabled') && !e.target.querySelector(':disabled')) {
            this.openDropdown(e.target);
            // Do not propagate click event when opening (ex: within an eui-card expandable header)
            e.stopPropagation();
        }
    }
    onClick() {
        if (this.isClosedOnClickInside && !this.activeDescendantKeyManager?.activeItem.subDropdown) {
            this.closeDropdown(true);
        }
    }
    /**
     * Open a dropdown
     * @param origin Origin of the dropdown position
     */
    openDropdown(origin) {
        this.origin = origin;
        if (!this.isTriggerFocusableOnClose(origin)) {
            this.origin = origin.closest('button:not([disabled])');
            if (!this.origin) {
                this.origin = origin.closest('a');
            }
            if (!this.origin) {
                this.origin = origin;
            }
        }
        if (!this.isOpen) {
            this.trapFocusAutoCapture = true;
            this.scrollDispatcherSubscription = this.scrollDispatcher.ancestorScrolled(this.origin)
                .pipe(takeUntil(this.destroy$))
                .subscribe((event) => {
                if (!this.isVisible(this.origin, event ? event.getElementRef().nativeElement : document.querySelector('body'))) {
                    this.trapFocusAutoCapture = false;
                    this.closeDropdown();
                }
            });
            const positionStrategy = this.getPositionStrategy();
            const scrollStrategy = this.overlay.scrollStrategies.reposition({ scrollThrottle: 10 });
            this.overlayRef = this.overlay.create({
                hasBackdrop: true,
                backdropClass: 'eui-dropdown__backdrop',
                panelClass: 'eui-dropdown__panel',
                positionStrategy,
                scrollStrategy,
            });
            this.overlayRef.attach(this.templatePortal);
            this.overlayRef.outsidePointerEvents().pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.closeDropdown();
            });
            this.overlayRef.backdropClick().pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.closeDropdown();
            });
            this.overlayRef.keydownEvents().pipe(takeUntil(this.destroy$)).subscribe((keyboardEvent) => {
                if (keyboardEvent.key?.toLowerCase() === 'escape') {
                    this.closeDropdown();
                }
            });
            if (this.hasDropdownItems) {
                this.euiDropdownItems.toArray().forEach((euiDropdownItem, i) => {
                    this.euiDropdownItemsClickSubscriptions[i] = fromEvent(euiDropdownItem.elementRef.nativeElement, 'click').subscribe(() => {
                        this.activeDescendantKeyManager.setActiveItem(euiDropdownItem);
                        if (this.activeDescendantKeyManager.activeItem.subDropdown) {
                            this.activeDescendantKeyManager.activeItem.subDropdown.setParentDropdown(this);
                            this.activeDescendantKeyManager.activeItem.subDropdown.overlayRef.detachBackdrop();
                            this.keydownListenerSubscription.unsubscribe();
                        }
                        if (this.isLabelUpdatedFromSelectedItem) {
                            this.triggerRef.nativeElement.querySelector('button').innerText = euiDropdownItem.elementRef.nativeElement.innerText;
                        }
                    });
                });
                this.activeDescendantKeyManager = new ActiveDescendantKeyManager(this.euiDropdownItems)
                    .withHomeAndEnd(true)
                    .withVerticalOrientation(true);
                this.activeDescendantKeyManager.setFirstItemActive();
            }
            this.createKeyboardHandlerSubscription();
            this.isOpen$.next(true);
        }
    }
    /**
     * Close a dropdown
     */
    closeDropdown(recursively = false) {
        this.isOpen$.next(false);
        this.euiDropdownItemsClickSubscriptions.forEach((euiDropdownItemsClickSubscription) => {
            euiDropdownItemsClickSubscription.unsubscribe();
        });
        this.keydownListenerSubscription.unsubscribe();
        if (this.hasDropdownItems) {
            this.activeDescendantKeyManager?.setFirstItemActive();
        }
        this.scrollDispatcherSubscription.unsubscribe();
        this.activeDescendantKeyManagerChangeSubscription.unsubscribe();
        this.overlayRef.dispose();
        this.overlayRef = null;
        this.activeDescendantKeyManager = null;
        if (this.trapFocusAutoCapture) {
            this.origin.focus();
        }
        if (recursively && this.parentDropdown) {
            this.parentDropdown.closeDropdown(true);
        }
    }
    createKeyboardHandlerSubscription() {
        this.keydownListenerSubscription = fromEvent(document, 'keydown').subscribe((event) => {
            if (this.isOpen) {
                if (event.code === 'Enter') {
                    this.activeDescendantKeyManager.activeItem.focus();
                    this.activeDescendantKeyManager.activeItem.click();
                    if (this.activeDescendantKeyManager?.activeItem.subDropdown) {
                        this.activeDescendantKeyManager.activeItem.subDropdown.setParentDropdown(this);
                        this.keydownListenerSubscription.unsubscribe();
                    }
                }
                else if (event.code === 'ArrowLeft') {
                    if (this.parentDropdown) {
                        this.parentDropdown.createKeyboardHandlerSubscription();
                        this.closeDropdown();
                    }
                }
                else if (event.code === 'ArrowRight') {
                    if (this.activeDescendantKeyManager.activeItem.subDropdown) {
                        this.activeDescendantKeyManager.activeItem.focus();
                        this.activeDescendantKeyManager.activeItem.click();
                        this.activeDescendantKeyManager.activeItem.subDropdown.setParentDropdown(this);
                        this.keydownListenerSubscription.unsubscribe();
                    }
                }
                else if (event.code === 'Tab') {
                    this.closeDropdown();
                }
                else {
                    this.activeDescendantKeyManager?.onKeydown(event);
                }
            }
            event.preventDefault();
        });
    }
    setParentDropdown(parentDropdown) {
        this.parentDropdown = parentDropdown;
        this.position = 'right';
        this.setPosition();
        const positionStrategy = this.getPositionStrategy();
        this.overlayRef.updatePositionStrategy(positionStrategy);
    }
    get hasDropdownItems() {
        return this.euiDropdownItems.length > 0;
    }
    getPositionStrategy() {
        return this.overlay.position()
            .flexibleConnectedTo(this.origin)
            .withPositions([
            new ConnectionPositionPair({ originX: this.originX, originY: this.originY }, { overlayX: this.overlayX, overlayY: this.overlayY }),
            new ConnectionPositionPair({ originX: this.fallbackOriginX, originY: this.fallbackOriginY }, { overlayX: this.fallbackOverlayX, overlayY: this.fallbackOverlayY }),
        ])
            .withFlexibleDimensions(false)
            .withLockedPosition(true);
    }
    isVisible(origin, scrollableParent) {
        const originY = origin.getBoundingClientRect().y;
        const scrollableParentY = Math.abs(scrollableParent.getBoundingClientRect().y);
        const scrollableParentHeight = scrollableParent.getBoundingClientRect().height - 50;
        return (originY > 0 && originY < scrollableParentHeight) || (originY - scrollableParentY > 0 && originY < scrollableParentY + scrollableParentHeight);
    }
    isTriggerFocusableOnClose(origin) {
        return origin.matches('button:not([disabled])') || origin.matches('a');
    }
    setPosition() {
        if (this.position === 'top') {
            this.originY = 'top';
            this.overlayY = 'bottom';
            this.fallbackOriginY = 'bottom';
            this.fallbackOverlayY = 'top';
            if (this.isDropDownRightAligned) {
                this.originX = 'end';
                this.overlayX = 'end';
                this.fallbackOriginX = 'end';
                this.fallbackOverlayX = 'end';
            }
        }
        if (this.position === 'right') {
            this.originX = 'end';
            this.overlayX = 'start';
            this.overlayY = 'center';
            this.fallbackOriginX = 'start';
            this.fallbackOverlayX = 'end';
            this.fallbackOverlayY = 'center';
        }
        if (this.position === 'bottom') {
            this.originY = 'bottom';
            this.overlayY = 'top';
            this.fallbackOriginX = 'start';
            this.fallbackOverlayX = 'start';
            this.fallbackOriginY = 'top';
            this.fallbackOverlayY = 'bottom';
            if (this.isDropDownRightAligned) {
                this.originX = 'end';
                this.overlayX = 'end';
                this.fallbackOriginX = 'end';
                this.fallbackOverlayX = 'end';
            }
        }
        if (this.position === 'left') {
            this.originX = 'start';
            this.overlayX = 'end';
            this.overlayY = 'center';
            this.fallbackOriginX = 'end';
            this.fallbackOverlayX = 'start';
            this.fallbackOverlayY = 'center';
        }
    }
}
/** @nocollapse */ EuiDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownComponent, deps: [{ token: i1$1.Overlay }, { token: i0.ViewContainerRef }, { token: i1$1.ScrollDispatcher }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiDropdownComponent, selector: "eui-dropdown", inputs: { e2eAttr: "e2eAttr", tabIndex: "tabIndex", width: "width", position: "position", isDropDownRightAligned: "isDropDownRightAligned", isClosedOnClickInside: "isClosedOnClickInside", isLabelUpdatedFromSelectedItem: "isLabelUpdatedFromSelectedItem" }, host: { properties: { "class": "this.cssClasses" } }, queries: [{ propertyName: "euiDropdownItems", predicate: EuiDropdownItemComponent, descendants: true }], viewQueries: [{ propertyName: "templatePortalContent", first: true, predicate: ["templatePortalContent"], descendants: true }, { propertyName: "triggerRef", first: true, predicate: ["triggerRef"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #triggerRef class=\"eui-dropdown__trigger-container\" (click)=\"onTriggerClicked($event)\">\n    <ng-content></ng-content>\n</div>\n\n<ng-template #templatePortalContent>\n    <div\n        attr.data-e2e=\"{{ e2eAttr }}\"\n        role=\"menu\"\n        [@openClose]=\"isOpen ? 'open' : 'closed'\"\n        cdkTrapFocus\n        class=\"eui-dropdown__panel-container\"\n        [style.width]=\"width\"\n        [tabindex]=\"tabIndex\"\n        (click)=\"onClick()\">\n        <ng-content select=\"eui-dropdown-content\"></ng-content>\n    </div>\n</ng-template>\n", styles: [".eui-dropdown .eui-dropdown__trigger-container{display:inline}.eui-dropdown__panel-container{background:#fff;border-radius:4px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;height:auto;display:block;position:relative;min-width:8rem}.eui-dropdown__panel-container .eui-dropdown-item{background:none;border:none;box-shadow:none;cursor:pointer;display:block;outline:none;padding:var(--eui-base-spacing-xs) var(--eui-base-spacing-s);position:relative;-webkit-tap-highlight-color:transparent;text-align:left;text-decoration:none;-webkit-user-select:none;user-select:none;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container{align-items:center;display:flex}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content,.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-text{align-items:center;display:flex;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-icon{align-items:center;display:flex;margin-left:var(--eui-base-spacing-s)}.eui-dropdown__panel-container .eui-dropdown-item:hover{background-color:var(--eui-base-color-grey-5)}.eui-dropdown__panel-container .eui-dropdown-item--active{background-color:var(--eui-base-color-grey-10)}\n"], dependencies: [{ kind: "directive", type: i2$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [openClose], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-dropdown', animations: [openClose], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div #triggerRef class=\"eui-dropdown__trigger-container\" (click)=\"onTriggerClicked($event)\">\n    <ng-content></ng-content>\n</div>\n\n<ng-template #templatePortalContent>\n    <div\n        attr.data-e2e=\"{{ e2eAttr }}\"\n        role=\"menu\"\n        [@openClose]=\"isOpen ? 'open' : 'closed'\"\n        cdkTrapFocus\n        class=\"eui-dropdown__panel-container\"\n        [style.width]=\"width\"\n        [tabindex]=\"tabIndex\"\n        (click)=\"onClick()\">\n        <ng-content select=\"eui-dropdown-content\"></ng-content>\n    </div>\n</ng-template>\n", styles: [".eui-dropdown .eui-dropdown__trigger-container{display:inline}.eui-dropdown__panel-container{background:#fff;border-radius:4px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;height:auto;display:block;position:relative;min-width:8rem}.eui-dropdown__panel-container .eui-dropdown-item{background:none;border:none;box-shadow:none;cursor:pointer;display:block;outline:none;padding:var(--eui-base-spacing-xs) var(--eui-base-spacing-s);position:relative;-webkit-tap-highlight-color:transparent;text-align:left;text-decoration:none;-webkit-user-select:none;user-select:none;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container{align-items:center;display:flex}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content,.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-text{align-items:center;display:flex;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-dropdown__panel-container .eui-dropdown-item .eui-dropdown-item__container .eui-dropdown-item__content .eui-dropdown-item__content-icon{align-items:center;display:flex;margin-left:var(--eui-base-spacing-s)}.eui-dropdown__panel-container .eui-dropdown-item:hover{background-color:var(--eui-base-color-grey-5)}.eui-dropdown__panel-container .eui-dropdown-item--active{background-color:var(--eui-base-color-grey-10)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Overlay }, { type: i0.ViewContainerRef }, { type: i1$1.ScrollDispatcher }]; }, propDecorators: { e2eAttr: [{
                type: Input
            }], tabIndex: [{
                type: Input
            }], width: [{
                type: Input
            }], position: [{
                type: Input
            }], templatePortalContent: [{
                type: ViewChild,
                args: ['templatePortalContent']
            }], triggerRef: [{
                type: ViewChild,
                args: ['triggerRef']
            }], euiDropdownItems: [{
                type: ContentChildren,
                args: [EuiDropdownItemComponent, { descendants: true }]
            }], isDropDownRightAligned: [{
                type: Input
            }], isClosedOnClickInside: [{
                type: Input
            }], isLabelUpdatedFromSelectedItem: [{
                type: Input
            }], cssClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class EuiDropdownModule {
}
/** @nocollapse */ EuiDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownModule, declarations: [EuiDropdownComponent,
        EuiDropdownItemComponent,
        EuiDropdownContentDirective], imports: [CommonModule,
        OverlayModule,
        ScrollingModule,
        A11yModule,
        EuiIconModule], exports: [EuiDropdownComponent,
        EuiDropdownItemComponent,
        EuiDropdownContentDirective] });
/** @nocollapse */ EuiDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownModule, imports: [CommonModule,
        OverlayModule,
        ScrollingModule,
        A11yModule,
        EuiIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        OverlayModule,
                        ScrollingModule,
                        A11yModule,
                        EuiIconModule,
                    ],
                    declarations: [
                        EuiDropdownComponent,
                        EuiDropdownItemComponent,
                        EuiDropdownContentDirective,
                    ],
                    exports: [
                        EuiDropdownComponent,
                        EuiDropdownItemComponent,
                        EuiDropdownContentDirective,
                    ],
                }]
        }] });
class EuiDropdownContentModule {
}
/** @nocollapse */ EuiDropdownContentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiDropdownContentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentModule });
/** @nocollapse */ EuiDropdownContentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDropdownContentModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiDropdownComponent, EuiDropdownContentDirective, EuiDropdownContentModule, EuiDropdownItemComponent, EuiDropdownModule };
